import dateTimeFilter from './dateTimeFilter'
import translate from './translateFilter'
import Vue from 'vue'

export default () => {
  Vue.filter('dateTime', dateTimeFilter)
  Vue.filter('translate', translate)
}
